// Shared enums and helpers for the luna-* component library.
// Kept as a plain module (no class) — shared constants, not an abstraction.

export type PuzzleId =
  | 'map'
  | 'pegs'
  | 'rectangles'
  | 'tents'
  | 'unruly'
  | 'untangle';

export const PUZZLE_IDS: readonly PuzzleId[] = [
  'map',
  'pegs',
  'rectangles',
  'tents',
  'unruly',
  'untangle',
];

export function isPuzzleId(value: string): value is PuzzleId {
  return (PUZZLE_IDS as readonly string[]).includes(value);
}

export type DifficultyLevel =
  | 'easy'
  | 'normal'
  | 'hard'
  | 'tricky'
  | 'unreasonable';

export const DIFFICULTY_LEVELS: readonly DifficultyLevel[] = [
  'easy',
  'normal',
  'hard',
  'tricky',
  'unreasonable',
];

export function isDifficultyLevel(value: string): value is DifficultyLevel {
  return (DIFFICULTY_LEVELS as readonly string[]).includes(value);
}

export const DIFFICULTY_LABELS: Record<DifficultyLevel, string> = {
  easy: 'Easy',
  normal: 'Normal',
  hard: 'Hard',
  tricky: 'Tricky',
  unreasonable: 'Unreasonable',
};

export type NavTarget = 'home' | 'programme' | 'appearance';

export const NAV_TARGETS: readonly NavTarget[] = ['home', 'programme', 'appearance'];

export function isNavTarget(value: string): value is NavTarget {
  return (NAV_TARGETS as readonly string[]).includes(value);
}

/** Log a developer-facing warning, suppressed in production builds. */
export function devWarn(message: string): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.warn(`[luna] ${message}`);
  }
}
